import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface DialogData {
  announcementData: any;
}
@Component({
  selector: 'app-announcement-detail',
  templateUrl: './announcement-detail.component.html',
  styleUrls: ['./announcement-detail.component.css']
})
export class AnnouncementDetailComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AnnouncementDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
   
  }
  onNoClick() {
    this.dialogRef.close();
  }
  dismissMessage(id){
    this.dialogRef.close(id);
  }




}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-master/announcement-detail/announcement-detail.component.ts